import { React } from "react";
import Raschety from "../../components/documenty/raschet/Raschety";




function RaschetPage(props) {
  return (
    <>
    <Raschety />
    </>
  );
}

export default RaschetPage;



